import Vue from "vue";
import Vuex from "vuex";

import app from "../main";
import menu from "./modules/menu";
import user from "./modules/user";
import moment from "moment";
// import chat from "./modules/chat";
// import todo from "./modules/todo";
// import survey from "./modules/survey";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    windowHeight: 0,
    windowWidth: 0,
    stateNotification: false,
    regionDetail: {},
    newsDetails: {},
    leftMenuIndex: 0,
    currentLocation: "",
  },
  getters: {
    getWindowHeight: (state) => state.windowHeight,
    getWindowWidth: (state) => state.windowWidth,
    getCart: (state) => state.cart,
    notification: (state) => state.stateNotification,
    regionDetail: (state) => state.regionDetail,
    newsDetails: (state) => state.newsDetails,
    leftMenuIndex: (state) => state.leftMenuIndex,
    currentLocation: (state) => state.currentLocation,
  },
  mutations: {
    changeLang(state, payload) {
      // app.$i18n.locale = payload;
      // localStorage.setItem("currentLanguage", payload);
    },
    changeHeightWindow(state, height) {
      state.windowHeight = height;
    },
    changeWidthWindow(state, width) {
      state.windowWidth = width;
    },
    changeStateNotification(state, payload) {
      state.stateNotification = payload;
    },
    changeRegionDetail(state, payload) {
      state.regionDetail = payload;
    },
    changeNewsDetail(state, payload) {
      state.newsDetails = payload;
    },

    changeLeftMenuIndex(state, payload) {
      state.leftMenuIndex = payload;
    },
    changeCurrentLocation(state, payload) {
      state.currentLocation = payload;
    },
  },
  actions: {
    setLang({ commit }, payload) {
      commit("changeLang", payload);
    },
    setHeightWindow({ commit }, payload) {
      commit("changeHeightWindow", payload);
    },
    setWidthWindow({ commit }, payload) {
      commit("changeWidthWindow", payload);
    },
    setNotification({ commit }, payload) {
      commit("changeStateNotification", payload);
    },
    setCart({ commit }, payload) {
      commit("changeCart", payload);
    },
    setRegionDetail({ commit }, payload) {
      commit("changeRegionDetail", payload);
    },
    setNewsDetail({ commit }, payload) {
      commit("changeNewsDetail", payload);
    },

    setLeftMenuIndex({ commit }, payload) {
      commit("changeLeftMenuIndex", payload);
    },
    setCurrentLocation({ commit }, payload) {
      if (navigator.geolocation) {
        const success = (position) => {
          commit("changeCurrentLocation", { lat: position.coords.latitude, lng: position.coords.longitude });
        };
        const error = (err) => {
          payload.$notify({
            type: 'system', category: "Thông báo hệ thống", date: moment(new Date()).format("mm:hh DD/MM/yyyy"), title: err.message
          }, {
            duration: 3000,
            permanent: false,
          });
        };

        navigator.geolocation.getCurrentPosition(success, error);
      } else {
        x.innerHTML = "Geolocation is not supported by this browser.";
      }
    },
  },
  modules: {
    menu,
    user,
  },
});
